import { render, staticRenderFns } from "./ShopCode.vue?vue&type=template&id=5047a6b4&scoped=true"
import script from "./ShopCode.vue?vue&type=script&lang=js"
export * from "./ShopCode.vue?vue&type=script&lang=js"
import style0 from "./ShopCode.vue?vue&type=style&index=0&id=5047a6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047a6b4",
  null
  
)

export default component.exports